import axios from "axios";
import { BaseService } from "./base.service";
import store from "../store";
// import { terminologies } from "../store/terminology.module";
/// const baseUrl = "http://api.epicai.local/index.php/";
const baseUrlPrefix = "https://api-";
// const baseUrlPostfix = "epicai.com/";
const baseUrlPostfix = "epicai.com/";
// const baseUrlPostfix = "epicai.com/";
// const fileUrl=epicai.local/index.php/
import authHeaders from "./auth-headers";
import { Core } from "../helpers/core";
// import { terminology } from "../helpers/terminology";
import i18n from "../i18n";
const { t } = i18n.global;
import { terminology } from "../store/terminology.module.js";
// const { tc } = i18n.global;
import { PrimeIcons } from "@primevue/core/api";
import { localizedTerminology } from "../helpers/terminology-i18n.js";
export const USER_KEY = "epicai.user";
export class ApiService extends BaseService {
  t = t;
  // terminology = terminology.state.terminologies;
  get terminology() {
    return localizedTerminology();
  }
  store = store;
  subdomain = null;
  showLeftBar = true;
  previewNamespace = null;
  relations = ""; //commenting below as it affects on lots of sections
  // relations = "?expand=addresses,contacts,contacts.contactItems,files,files.file,files.file.commentsCount,headers.html,footers.html,header,body,messages.message,lineItems,links,directDeposit,journals.accounts,payments";
  labelKey = "display_name";
  permission = {
    invoice_approve: 1,
  };
  // Navigation Filter Key [define it if you are filtering a list by same column]
  navFilterKey = null;
  http = null;
  primaryNavItems = [
    {
      key: "all",
      label: "View All ",
      icon: PrimeIcons.LIST,
      type: 1,
      action: () => {
        this.get();
      },
    },
    {
      key: "bookmarks",
      label: this.t("viewMyBookmarks"),
      icon: PrimeIcons.BOOKMARK,
      type: 2,
      action: () => {
        this.get({}, `/bookmarks`);
      },
    },
    {
      key: "inactive",
      label: this.t("viewInactive"),
      icon: PrimeIcons.BAN,
      type: 3,
      action: () => {
        this.get({}, `/inactive`);
      },
    },
  ];
  buildEndPoint(moduleNode) {
    this.BASEURL = this.endpoint =
      baseUrlPrefix +
      (this.subdomain != "" ? this.subdomain + "." : "") +
      baseUrlPostfix;
    if (moduleNode) this.endpoint += moduleNode;
    this.http = axios.create({
      baseURL: this.endpoint,
      // timeout: 1000,
      headers: authHeaders(USER_KEY),
    });
  }
  constructor(moduleNode) {
    super();
    this.subdomain = Core.getSubdomain();
    this.buildEndPoint(moduleNode);

    this.http.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      },
    );
    // Add a response interceptor
    this.http.interceptors.response.use(
      function (response) {
        // Do something with response data
        return response;
      },
      function (error) {
        let packet = { errors: {}, message: null, status: 400 };
        if (error.response) {
          if (
            "422" == error.response.status ||
            "409" == error.response.status
          ) {
            // error.response.data.forEach((error) => {
            //   packet.errors[error.field] = error.message;
            // });
            // packet.errors = error.response.data;
            const data = error.response.data;
            if (Array.isArray(data)) {
              data.forEach((err) => {
                if (err.field === "numberSuggested") {
                  packet.numberSuggested = err.message;
                } else {
                  packet.errors[err.field] = err.message;
                }
              });
            } else {
              Object.keys(data).forEach((key) => {
                if (key !== "numberSuggested") {
                  packet.errors[key] = data[key];
                }
              });
              packet.numberSuggested = data.numberSuggested;
            }
            packet.status = error.response.status;
            packet.message = error.response.statusText;
          } else if (
            "412" == error.response.status ||
            "400" == error.response.status 
          ) {
            packet.message = error.response.data.message;
            packet.status = error.response.data.status;
          } else if ("401" == error.response.status) {
            store.dispatch("auth/logout");
          }
          // Request made and server responded
        } else if (error.request) {
          // The request was made but no response was received
        } else {
          packet.message = error.message;
          // Something happened in setting up the request that triggered an Error
        }

        // Do something with response error
        return Promise.reject(packet);
      },
    );
  }
  extraNode(node) {
    return this.endpoint + node;
  }
  normalizeFieldErrors(packet) {
    const normalized = {};
    const raw = packet?.errors;
    if (raw == null || typeof raw !== "object") return normalized;

    if (Array.isArray(raw)) {
      raw.forEach((err) => {
        if (err?.field != null && err.message != null) {
          normalized[String(err.field).replace(/\]\./g, "]")] = err.message;
        }
      });
      return normalized;
    }

    Object.entries(raw).forEach(([field, message]) => {
      if (field != null && message != null) {
        normalized[String(field).replace(/\]\./g, "]")] = message;
      }
    });
    return normalized;
  }
  processErrors(packet) {
    if (!this.formAnchor?.setErrors) return;
    const normalized = this.normalizeFieldErrors(packet);
    if (!Object.keys(normalized).length) return;
    this.formAnchor.setErrors(normalized);
  }
  uploadsDir() {
    return this.BASEURL + "uploads/";
  }
  filesDir(fileName) {
    if (!fileName) fileName = "";
    return this.uploadsDir() + "files/" + fileName;
  }
  scanFilterItmes(params) {
    let moduleNode = "/filter-items";
    return this.get(params, moduleNode).then((res) => {
      return res;
    });
  }
  all(params) {
    let moduleNode = "/all";
    return this.get(params, moduleNode).then((res) => {
      return res.items;
    });
  }

  count(params) {
    let moduleNode = "/count";
    return this.get(params, moduleNode).then((res) => {
      return res;
    });
  }

  getNextNumber() {
    return this.get({}, "/next-number");
  }

  loadJournal(id) {
    let moduleNode = "/" + id;
    moduleNode += "?expand=journals,journals.accounts,journals.entityLabel";
    return this.get({}, `${moduleNode}`).then((res) => res);
  }

  removePrintQueue(ids) {
    return this.post({ ids }, "/clear-print-queue");
  }

  decide({ id, ids, action, reason }) {
    const list = (Array.isArray(ids) && ids.length
      ? ids
      : id != null
        ? [id]
        : []
    ).filter((x) => x != null);
    if (!list.length) return Promise.reject(new Error("No id for decide"));

    const payload =
      list.length === 1 ? { id: list[0], action } : { ids: list, action };
    const reasonText =
      reason != null && String(reason).trim() !== ""
        ? String(reason).trim()
        : undefined;
    if (reasonText) payload.reason = reasonText;
    return this.post(payload, "/decide");
  }

  // allPost() {
  //   let moduleNode = "/all";
  //   return this.get(params, moduleNode).then((res) => {
  //     return res;
  //   });
  // }

  // getElemenyById(id) {
  //   let moduleNode = id;
  //   return this.get(id, moduleNode).then((res) => {
  //     return res;
  //   });
  // }

  refresh({ serviceId, data }) {
    return store
      .dispatch("fetch/refresh", {
        serviceId,
        data,
      })
      .then((res) => {
        return res;
      });
  }

  get(params, moduleNode) {
    if (!moduleNode) moduleNode = "";
    return this.http
      .get(`${moduleNode}`, { params: params })
      .then((res) => res.data);
  }

  retrieve(id, params) {
    let moduleNode = "/" + id;
    if (!params) {
      moduleNode += this.relations;
    }

    return this.get(params, `${moduleNode}`).then((res) => res);
  }

  delete(item, moduleNode) {
    if (!moduleNode) moduleNode = "";
    let id = item.id;
    return this.http
      .delete(`${this.endpoint}/${moduleNode + id}`, { headers: authHeaders() })
      .then((res) => res.data);
  }
  retrieveByID(id) {
    this.endpoint += id;
    return this.http
      .get(`${this.endpoint}`, { headers: authHeaders() })
      .then((res) => res.data);
  }
  retrieveByUrl(params) {
    this.endpoint += params;
    return this.http
      .get(`${this.endpoint}`, { headers: authHeaders() })
      .then((res) => res.data);
  }

  post(payload, moduleNode) {
    if (!moduleNode) moduleNode = "";
    const vm = this;
    return this.http
      .post(`${moduleNode}`, payload)
      .then((res) => res.data)
      .catch(function (error) {
        if (vm && vm.formAnchor && vm.processErrors) vm.processErrors(error);

        return Promise.reject(error);
      });
  }
  put(payload, moduleNode) {
    if (!moduleNode) moduleNode = "";
    const vm = this;
    return this.http
      .put(`${moduleNode}`, payload)
      .then((res) => res.data)
      .catch(function (error) {
        vm.processErrors(error);
        return Promise.reject(error);
      });
  }

  save(payload, moduleNode) {
    if (!moduleNode) moduleNode = "";
    let processor =
      payload.id > 0
        ? this.http.put(
            payload.id + (moduleNode ? "/" + moduleNode : ""),
            payload,
          )
        : this.http.post(moduleNode, payload);
    const vm = this;
    return processor
      .then((res) => res.data)
      .catch(function (error) {
        vm.processErrors(error);
        return Promise.reject(error);
      });
  }

  hookName(type) {
    let hookName = null;
    switch (type) {
      case "pre":
        hookName = "pre.save." + this.namespace;
        break;
      case "post":
        hookName = "post.save." + this.namespace;
        break;
      default:
        hookName = "pre.save." + this.namespace;
        break;
    }
    return hookName;
  }

  async getListFilter(service) {
    if (service) {
      return store
        .dispatch("fetch/refresh", {
          serviceId: service.serviceId,
          data: { domain: this.DOMAIN, ...service.params },
        })
        .then((res) => {
          return res[service.serviceId];
        });
    }
    return null;
  }
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "detail",
        label: "Preview an Invoice",
        icon: "Eye",
      },
      {
        key: "edit",
        label: "Edit an Invoice",
        icon: "edit",
      },
      {
        key: "announce",
        label: "announceThisEntity",
        services: -3,
        icon: "Announcement",
      },
      {
        key: "email",
        label: "emailThisEntity",
        icon: "Mail",
        services: 208,
      },
      {
        key: "bookmark",
        label: "bookmarkThisEntity",
        icon: "Bookmark",
      },
    ];
    return listMenuItems;
  }
}
